import { combineReducers } from 'redux'
import Authentication from './Authentication'
import DetailMyOb from './DetailMyOb'
import Setting from './Setting'
import Set_Basic_Info from './Newobservation_basic_info'
import Set_Checklist from './Newobservation_Checklist'

export default combineReducers({
    authen: Authentication,
    detailMyOb: DetailMyOb,
    setting: Setting,
    set_basic_info: Set_Basic_Info,
    set_checklist: Set_Checklist
})